import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useAllShortcutDefinitions } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/useAllShortcutDefinitions.js';
import { ModalLoader } from '#pplx/frontend/apps/ask/modals/ModalLoader.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useCallback } from 'react';
const KeyboardShortcutHelperModal = Dynamic(async () => {
    const { KeyboardShortcutHelperModal } = await import('#pplx/frontend/apps/ask/ask-input/ask-input-misc/components/KeyboardShortcutHelperModal.js');
    return { default: KeyboardShortcutHelperModal };
}, { loading: ModalLoader });
const KeyboardShortcutEditorModal = Dynamic(async () => {
    const { KeyboardShortcutEditorModal } = await import('#pplx/frontend/apps/ask/ask-input/ask-input-misc/components/KeyboardShortcutEditorModal.js');
    return { default: KeyboardShortcutEditorModal };
}, { loading: ModalLoader });
export function useOpenKeyboardShortcutsModal() {
    const { openModal } = useModalContext();
    const { device: { isWindowsApp }, } = useWebPlatform();
    const shortcutSections = useAllShortcutDefinitions();
    return useCallback(() => {
        if (isWindowsApp) {
            openModal(KeyboardShortcutEditorModal, {}, { replace: true });
            return;
        }
        openModal(KeyboardShortcutHelperModal, { sections: shortcutSections }, { replace: true });
    }, [isWindowsApp, openModal, shortcutSections]);
}
//# sourceMappingURL=useOpenKeyboardShortcutsModal.js.map